import request from 'meinian-package/src/utils/request'
import { useUpdate } from 'ahooks'

export default (item, onInit) => {
  const update = useUpdate()
  const onViewed = async () => {
    const res = await request.post('/backend-api/notify/website/notify/read-notifies', { notifyIdList: [item.notifyId] })
    if (res) {
      item.viewed = 1
      update()
      await onInit()
    }
  }
  return {
    onViewed
  }
}
